module.exports = __webpack_public_path__ + "img/group.901d4606.svg";